export const REQUEST_TOKEN_INTERCEPTOR = [
  config => {
    if (localStorage.getItem('stateAntiFraud') != null) {
      config.headers['Authorization'] = `bearer ${JSON.parse(localStorage.getItem('stateAntiFraud')).token}`
    }

    return config
  }
]
